import { connect } from 'react-redux';
import Layout from '../../components/Layout';

const mapState = (state) => ({
  isConnected: state.user.isConnected,
});

const mapDispatch = () => ({});

export default connect(mapState, mapDispatch)(Layout);
